module.exports = __webpack_public_path__ + "img/next-track-button.b4ea6a65.svg";